<template>
  <div class="container-fluid">
    <PageHeader
      :page="page"
      :has-return="true"
      :left-side-class="'col-xl-8'"
      :right-side-class="
        'col-xl-4 align-items-end d-flex pb-2 justify-content-end'
      "
    >
      <template v-slot:customActions>
        <action-button
          v-show="
            currentTabState &&
              currentTabState.showActions.includes('save') &&
              !isReadOnly
          "
          variant="success m-1"
          i="fas fa-save"
          :responsive="false"
          text="Guardar"
          @click="save"
        />
        <action-button
          v-show="
            (currentTabState &&
              currentTabState.showActions.includes('submit') &&
              !isReadOnly) ||
              (hasPermisionChangeAcademicYear && model.id > 0)
          "
          v-if="!isSubmitted"
          variant="success m-1"
          i="fas fa-save"
          :responsive="false"
          text="Someter"
          @click="submit"
        />
        <action-button
          v-show="
            currentTabState &&
              currentTabState.showActions.includes('continue') &&
              !isReadOnly &&
              !isSubmitted
          "
          variant="success m-1"
          i="fas fa-arrow-circle-right"
          :responsive="false"
          text="Continuar"
          @click="onContinue"
        />
      </template>
    </PageHeader>

    <ChangeOfStatusReadonly />
    <ValidationObserver ref="observer" novalidate slim>
      <Section1
        :key="componentKey"
        :municipalities-list="municipalities"
        :academic-years-list="academicYears"
        :model="model"
        :is-expanded="isExpandedSection1"
        :is-read-only="isReadOnlyAfterCreate"
        :delete-documents="deleteDocuments"
        :show-msg-error-section1="showMsgErrorSection1"
        :sections-states="currentTabSectionsState"
        :student-sie="studentSieId"
        @expanded="onExpanded"
        @resetMsgErrorSection1="resetMsgErrorSection1"
        @resetTypeValidation="resetTypeValidation"
        @onDeleteTapRequest="save"
        @documentReplaced="getStudentTapRequest"
      />
    </ValidationObserver>

    <template v-if="model.id">
      <ValidationObserver ref="main-form">
        <div class="my-3">
          <Section2
            :model="model"
            :is-read-only="isReadOnly"
            :sections-states="currentTabSectionsState"
          />
        </div>

        <div class="my-3">
          <ValidationProvider
            v-slot="{ validate, errors }"
            :rules="{
              required: currentTabSectionsState[
                enums.sections['Servicios Provistos']
              ].readonly
                ? false
                : { allowFalse: false },
            }"
          >
            <ServicesProvided
              ref="related-service"
              :tap-request-id="model.id"
              :submitted="
                currentTabSectionsState[enums.sections['Servicios Provistos']]
                  .readonly || isReadOnly
              "
              @input="validate"
            />
            <Error
              v-if="errors[0]"
              variant="no-border"
              message="Favor de añadir servicios provistos."
            />
          </ValidationProvider>
        </div>

        <div class="my-3">
          <UbicationAlternative
            :model="model.alternativeUbication"
            :is-read-only="
              currentTabSectionsState[enums.sections['Alternativa Ubicación']]
                .readonly || isReadOnly
            "
          />
        </div>

        <div class="my-3">
          <ValidationProvider
            v-slot="{ validate, errors }"
            :rules="{
              required: currentTabSectionsState[
                enums.sections['Propósito Consulta']
              ].readonly
                ? false
                : { allowFalse: false },
            }"
          >
            <Purposes
              :purposes="model.purposes"
              :submitted="
                currentTabSectionsState[enums.sections['Propósito Consulta']]
                  .readonly || isReadOnly
              "
              @input="validate"
            />
            <Error
              v-if="errors[0]"
              variant="no-border"
              message="Favor marcar el propósito de la consulta."
            />
          </ValidationProvider>
        </div>

        <div v-if="canViewServices" class="col-12">
          <ValidationProvider
            v-slot="{ validate, errors }"
            :rules="{
              required: { allowFalse: false },
            }"
            :custom-messages="{
              required: 'Favor de añadir al menos un servicio.',
            }"
          >
            <ServicesSummary
              :services="model.servicesSummary"
              :costByServices="costByServices"
              :collections="availableCatalogOptions"
              :hideTotal="true"
              :readonly="
                currentTabSectionsState[enums.sections['Servicios Provistos']]
                  .readonly || isReadOnly
              "
              :isAcceptBtnDisabled="isAcceptBtnDisabled"
              @on-service-change="onServiceChange"
              @add-service="addServiceToSummary"
              @input="validate"
              @remove-service="removeServiceFromSummary"
            />

            <Error v-if="errors[0]" variant="no-border" :message="errors[0]" />
          </ValidationProvider>
        </div>

        <div class="my-3">
          <ValidationProvider
            v-slot="{ errors }"
            vid="document"
            :custom-messages="{ required: 'Favor anejar un documento.' }"
          >
            <Documents
              :key="documentLength"
              :documents="document.data"
              :document-types="documentTypes"
              :disabled="
                currentTabSectionsState[enums.sections['Documentos']]
                  .readonly || isReadOnly
              "
              @files="gettingDocument($event)"
            />
            <Error v-if="errors[0]" variant="no-border" :message="errors[0]" />
            <Error v-if="errors[1]" variant="no-border" :message="errors[1]" />
          </ValidationProvider>
        </div>

        <div class="my-3">
          <ValidationProvider
            v-slot="{ validate, errors }"
            :rules="{
              required:
                currentTabSectionsState[
                  enums.sections['Funcionarios Solicitan']
                ].readonly ||
                isReadOnly ||
                isCurrentUserSigned
                  ? false
                  : { allowFalse: false },
            }"
          >
            <Requesters
              :keep-signed="
                !(
                  currentTabSectionsState[
                    enums.sections['Funcionarios Solicitan']
                  ].readonly || isReadOnly
                )
              "
              :allow-add-more="
                !(
                  currentTabSectionsState[
                    enums.sections['Funcionarios Solicitan']
                  ].readonly || isReadOnly
                )
              "
              :submitted="
                currentTabSectionsState[
                  enums.sections['Funcionarios Solicitan']
                ].readonly || isReadOnly
              "
              :requesters="model.requesters"
              :positions-list="requestersPositionsList"
              @input="validate"
            />
            <Error
              v-if="errors[0]"
              variant="no-border"
              message="Favor escriba los funcionarios que solicitan la consulta."
            />
          </ValidationProvider>
        </div>

        <div class="my-3">
          <div class="row">
            <div class="col-12">
              <div class="tag-badge pl-2">
                <span class="dot text-center">
                  <i
                    class="far fa-check-circle orange-icon orange-icon-badge-align"
                  />
                </span>
                <span class="tag-badge-title py-1 pl-2">
                  Términos y Responsabilidades
                </span>
              </div>
              <div class="row mx-1">
                <div class="col-12 px-0">
                  <div class="border-box">
                    Certifico por este medio, que esta solicitud se encontrará
                    en el expediente físico del estudiante firmado por todas las
                    partes involucradas. (0502)
                  </div>
                </div>
              </div>
              <ValidationProvider
                v-slot="{ errors }"
                name="checkboxConditions"
                :rules="{ required: { allowFalse: false } }"
              >
                <div class="row mx-1">
                  <div
                    class="border-box"
                    :class="{
                      error: errors.length > 0,
                      signed: termsSelected,
                      unsigned: !termsSelected,
                    }"
                  >
                    <div class="col-12 px-0 py-0 h-100">
                      <div class="custom-control custom-checkbox h-100">
                        <div
                          class="custom-control custom-checkbox h-100 d-flex justify-content-start align-items-center"
                        >
                          <input
                            id="checkboxConditions"
                            v-model="termsSelected"
                            :disabled="
                              currentTabSectionsState[
                                enums.sections['Terminos y Responsabilidades']
                              ].readonly || isReadOnly
                            "
                            type="checkbox"
                            class="custom-control-input"
                            name="checkboxConditions"
                          />
                          <label
                            class="custom-control-label pl-md-3"
                            for="checkboxConditions"
                          >
                            Acepto los términos y responsabilidades
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Error
                  v-if="errors[0]"
                  variant="no-border"
                  message="Favor certificar los términos y responsabilidades."
                />
              </ValidationProvider>
            </div>
          </div>
        </div>
      </ValidationObserver>
    </template>
  </div>
</template>

<script>
import { Section1, Section2 } from './_components';
import {
  ServicesProvided,
  UbicationAlternative,
  Purposes,
  Documents,
  Requesters,
  ChangeOfStatusReadonly,
} from '@/components/pei/ubication-tech-assistance/_components';
import PageHeader from 'PageHeader';
import { Error } from '@/components/common';
import objectToFormData from 'object-to-formdata';
import alert from '@/mixin/alert.mixin';
import ActionButton from 'ActionButton';
import {
  getCurrentAcademicYear,
  getMunicipalities,
  getPositions,
  getPurposes,
  getDocumentTypesByCode,
  getStudentTapRequestById as _getStudentTapRequestById,
  getAcademicYears,
  hasTapRequest,
  getCentralLevelServices,
  getTherapyservicesfilters,
  getServiceCost,
  isSchoolContractDirectPayment as _isSchoolContractDirectPayment,
} from '@/services/api/tapRequest.api.js';
import {
  UTA_MANAGEMENT_SECTION_ENUM,
  UTA_MANAGEMENT_REQUEST_TYPE,
} from '@/components/pei/ubication-tech-assistance/_config/management';
import { mapActions, mapGetters } from 'vuex';
import {
  statusManagementStore,
  registerStatusManagementStore,
  unregisterStatusManagementStore,
} from '@/components/pei/ubication-tech-assistance/_store';
import { tapRequestStatusesEnum } from '../../../_types';
import ServicesSummary from '@/components/pei/ubication-tech-assistance/management/_components/CentralLevelAnalysis/components/ServicesSummary/Main.vue';
import { serviceEnum } from '@/components/pei/ubication-tech-assistance/management/_types.js';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import codeDocumentTypes from '@/utils/constants/documentTypes';

const QuestionsEnum = { Purposes: 36 };
const purposeAnswerEnum = { other: 226 };

const modelInitialState = () => ({
  id: null,
  municipality: {},
  municipalityId: 0,
  academicYear: {},
  academicYearId: 0,
  facilitatorName: null,
  facilitatorDiscussionOccurred: false,
  facilitatorDiscussionDescription: null,
  facilitatorDiscussionFile: null,
  studentEducationalFunctioningDesc: null,
  alternativeUbication: {
    ageRange: null,
    alternative: null,
    justification: null,
    description: null,
    focusTypeId: null,
    gradeId: null,
  },
  sectionsQuestions: [],
  arrangements: [],
  requesters: [],
  purposes: [],
  requestType: null,
  determinationType: null,
  statusId: null,
  servicesSummary: [],
  familyMemberName: null,
  relative: null,
  phone: null,
  email: null,
});

const modelToContinuePayload = (
  studentSieId,
  academicYearId,
  {
    facilitatorDiscussionOccurred,
    facilitatorDiscussionDescription,
    facilitatorDiscussionFile,
    municipalityId,
    facilitatorName,
    requestType,
    familyMemberName,
    relative,
    phone,
    email,
  }
) => ({
  studentSieId,
  academicYearId,
  facilitatorDiscussionOccurred,
  facilitatorDiscussionDescription,
  facilitatorDiscussionFile,
  facilitatorName,
  municipalityId,
  requestType,
  familyMemberName,
  relativeId: relative?.id,
  phone,
  email,
});

const modelToPayload = (studentSieId, academicYearId, model) => {
  const _model = modelToContinuePayload(studentSieId, academicYearId, model);
  const {
    id,
    studentEducationalFunctioningDesc,
    alternativeUbication,
    sectionsQuestions,
    purposes,
    arrangements,
    requesters,
    requestType,
    IsUpdatingAcademicYear,
    servicesSummary,
  } = model;

  const _sectionsQuestions =
    sectionsQuestions
      ?.filter((x) => x.questionId != purposeAnswerEnum.other)
      .map(({ answerId, questionId }) => ({
        questionId: questionId,
        answerId: answerId,
        otherAnswerText: null,
      })) || [];

  const _purposes =
    purposes
      ?.filter((x) => !!x.selected)
      .map(({ questionId, answerId, description }) => ({
        questionId,
        answerId,
        otherAnswerText: description,
      })) || [];

  const _arrangements =
    arrangements?.flatMap(({ selected }) =>
      selected?.map(({ areaId, id }) => ({
        arrangementAreaId: areaId,
        arrangementId: id,
      }))
    ) || [];

  const _requesters =
    requesters?.map(({ name, position, phone, email, signed }) => ({
      fullName: name,
      workPositionId: position?.id || null,
      telephoneNumber: phone,
      email,
      signed,
    })) || [];

  const _servicesSummary =
    servicesSummary?.map((item) => ({
      ...item,
      itinerantService: item.itinerantService?.id || false,
      therapyFrequencyId: item.therapyFrequency?.id || null,
      therapyServiceModalityId: item.therapyServiceModality?.id || null,
      therapyDurationId: item.therapyDuration?.id || null,
      serviceId: item.service?.id,
    })) || [];

  return {
    id,
    requestType,
    ..._model,
    enums: { sections: UTA_MANAGEMENT_SECTION_ENUM },
    //
    studentEducationalFunctioningDesc,
    isStudentPrescholar:
      alternativeUbication?.ageRange?.codeType ===
      'PeiAlternatePlacementPrescholar',
    recommendedPlacementJustification:
      alternativeUbication?.justification || null,
    recommendedPlacementId: alternativeUbication?.alternative?.id || null,
    recommendedPlacementGradeId: alternativeUbication?.grade?.id || null,
    recommendedPlacementFocusTypeId:
      alternativeUbication?.focusType?.id || null,
    recommendedPlacementDescription: alternativeUbication?.description || null,
    //
    questionnaireAnswers: [..._sectionsQuestions, ..._purposes],
    arrangements: _arrangements,
    staffMembers: _requesters,
    IsUpdatingAcademicYear,
    servicesSummary: _servicesSummary,
  };
};

export default {
  name: 'UbicationTechAssistanceWrapper',
  mixins: [alert],
  inject: {
    studentSieId: {
      default: 0,
    },
  },
  props: {
    readOnly: { type: Boolean, default: false },
  },
  watch: {
    'model.municipality'(newValue) {
      this.model.municipalityId = newValue.id;
    },
    'model.academicYear'(newValue) {
      this.model.academicYearId = newValue.id;
    },
    tapRequestId(newValue) {
      if (newValue && this.isSchoolContractDirectPayment === null) {
        this.fetchIsSchoolContractDirectPayment();
      }
    },
    deep: true,
    immediate: true,
  },
  data() {
    return {
      enums: {
        sections: UTA_MANAGEMENT_SECTION_ENUM,
      },
      sysParameters: [],
      isSubmitted: false,
      documentLength: 0,
      componentKey: 0,
      isExpandedSection1: true,
      showMsgErrorSection1: false,
      typeValidationError: false,
      showMsgErrorAlternatives: false,
      deleteDocuments: true,
      //
      model: modelInitialState(this.studentSieId),
      requestersPositionsList: [],
      municipalities: [],
      academicYears: [],
      // Data for component Document.
      document: {
        documentTypes: [],
        // Variables to save component data.
        data: {
          files: [],
          types: [],
        },
      },
      page: {
        icon: 'fas fa-user-edit',
        title: 'Solicitud de Asistencia Técnica para Ubicación del Estudiante',
        routes: [
          'PEI',
          'Solicitud de Asistencia Técnica para Ubicación del Estudiante',
        ],
      },
      hasServicesAdded: false,
      termsRequired: true,
      termsSelected: false,
      catalogs: {
        services: [],
        servicesPreviousYear: [],
        frequencies: [],
        modalities: [],
        durations: [],
      },
      headerInformation: {
        studentInfo: null,
        schoolName: null,
        status: null,
        impediment: null,
        requestNumber: null,
      },
      costByServices: [],
      disableAcceptBtn: null,
      isSchoolContractDirectPayment: null,
      tapRequestId: null,
    };
  },
  components: {
    Section1,
    Section2,
    ServicesProvided,
    UbicationAlternative,
    Requesters,
    PageHeader,
    Documents,
    Purposes,
    Error,
    ActionButton,
    ChangeOfStatusReadonly,
    ServicesSummary,
  },
  computed: {
    ...mapGetters(statusManagementStore, [
      'currentTabState',
      'currentTabSectionsState',
    ]),
    isAcceptBtnDisabled() {
      let isDisabled = false;

      if (this.isRenovationType) {
        return this.disableAcceptBtn;
      }

      return isDisabled;
    },
    getDocumentData() {
      return this.document.data;
    },
    isReadOnly() {
      return this.readOnly;
    },
    isReadOnlyAfterCreate() {
      return this.readOnly || !!this.model.id;
    },
    isPendingDiscussion() {
      return (
        this.model &&
        this.model.statusId ==
          tapRequestStatusesEnum['Pendiente Revision de Escuela']
      );
    },
    hasPermisionChangeAcademicYear() {
      return (
        this.$store.getters.HasPermission('taprequest.changeacademicyear') &&
        this.model.requestType != UTA_MANAGEMENT_REQUEST_TYPE.NUEVO
      );
    },
    availableCatalogOptions() {
      return {
        services: this.catalogs.services.filter(
          (s) =>
            s.id === serviceEnum.Other ||
            this.model.servicesSummary.every((ss) => ss.service.id != s.id)
        ),
        servicesPreviousYear: this.catalogs?.servicesPreviousYear,
        itinerantServices: [
          { id: true, name: 'Si' },
          { id: false, name: 'No' },
        ],
        frequencies: this.catalogs?.frequencies,
        modalities: this.catalogs?.modalities,
        durations: this.catalogs?.durations,
      };
    },
    isRenovationType() {
      return this.model.requestType == UTA_MANAGEMENT_REQUEST_TYPE.RENOVACION;
    },
    canViewServices() {
      return this.isRenovationType;
    },
    documentTypes() {
      const types = this.document?.documentTypes ?? [];
      // US:52391 - hide DocumentServiceCost type if isn't renovationType
      return this.isRenovationType
        ? types
        : types.filter((x) => x.id !== codeDocumentTypes.DocumentServiceCost);
    },
    headerInfos() {
      const info = this.headerInformation;
      const result = [
        {
          name: 'Estudiante',
          value: info.studentInfo,
          icon: 'fa-address-book',
        },
        { name: 'Estatus', value: info.status, icon: 'fa-flag' },
        { name: 'Escuela', value: info.schoolName, icon: 'fa-school' },
        {
          name: 'Impedimento',
          value: info.impediment,
          icon: 'fa-clipboard-list-check',
        },
      ];
      return result;
    },
    currentUserId() {
      return this.userProfile?.sub;
    },
    isCurrentUserSigned() {
      return this.model?.requesters?.some(
        (x) => x.signedBy === this.currentUserId
      );
    },
  },
  methods: {
    ...mapActions(statusManagementStore, ['setCurrentStatus']),
    // get the service cost from the company's contract per services only for Renovation.
    async onServiceChange(service) {
      this.disableAcceptBtn = false;
      if (!this.isRenovationType) return;

      const relatedServices =
        this.$refs['related-service']?.items?.related ?? [];

      const relatedServiceFound = relatedServices.find(
        (x) => x?.service?.id === service.disciplineTypeId
      );

      if (!relatedServiceFound) {
        this.ShowToast(
          'Error',
          'El costo de Terapia no puede ser añadido, ya que no se encuentra documentado en los Servicios Relacionados.',
          'error'
        );
        this.disableAcceptBtn = true;
        return;
      }
      if (!this.model?.id) return;

      if (this.isSchoolContractDirectPayment) {
        return;
      }

      const { data: resp } = await getServiceCost({
        tapRequestId: this.model?.id,
        disciplineTypeId: service.disciplineTypeId,
        durationId: relatedServiceFound?.duration?.id,
        modalityId: relatedServiceFound?.modality?.id,
      });

      this.costByServices.push({ serviceId: service.id, cost: resp });
    },
    async getMunicipalities() {
      const { data } = await getMunicipalities();
      this.municipalities = data;
    },
    async getAcademicYears() {
      let yearType = this.CanSignPei ? 'FUTURE' : 'CURRENT';

      const { data } = await getAcademicYears(yearType);
      this.academicYears = data;
    },
    async getCanSignPei() {
      const { data } = await getSysparameterByNames({
        parameterNames: ['CanSignPeiDate'],
      });

      let canSignPeiDate = data?.find((item) => item.name === 'CanSignPeiDate')
        ?.staticValue;

      this.CanSignPei = new Date() >= new Date(canSignPeiDate);
    },
    async getPurposes() {
      const { data } = await getPurposes(13);
      this.model.purposes = data
        .filter((x) => x.id === QuestionsEnum.Purposes)[0]
        .questions.map(({ id, text, answers: [first] }) => ({
          questionId: id,
          answerId: first?.id || null,
          text,
          description: '',
          selected: false,
        }));
    },
    async getCurrentAcademicYear() {
      getCurrentAcademicYear().then((res) => {
        this.academicYearId = res.data.id;
      });
    },
    async getPositions() {
      const { data } = await getPositions(17);
      this.requestersPositionsList = data;
    },
    groupBy(keys) {
      return (array) => {
        return array.reduce((objectsByKeyValue, obj) => {
          const value = keys.map((key) => obj[key]).join('-');
          objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(
            obj
          );
          return objectsByKeyValue;
        }, []);
      };
    },
    async getSysParam() {
      const { data: sysParameters } = await getSysparameterByNames({
        parameterNames: ['TapRequestRenewalNotRequireSAEE08Document'],
      });
      this.sysParameters = sysParameters;
    },
    prepareAreaArrangements(arrangements) {
      const groupByArea = this.groupBy(['arrangementAreaId']);
      return groupByArea(arrangements)
        .map((item) => ({
          area: {
            name: item[0].arrangementArea,
            id: item[0].arrangementAreaId,
          },
          selected: item.map((a) => ({
            areaId: a.arrangementAreaId,
            id: a.arrangementId,
            name: a.arrangement,
          })),
        }))
        .filter((r) => r !== undefined);
    },
    async getStudentTapRequest() {
      if (!this.tapRequestId) {
        //This is for reset status when request is not exist.
        this.setCurrentStatus({
          id: 'NONE',
          name: '',
          reason: '',
          reasonTypes: [],
        });
        return;
      }

      const { data } = await _getStudentTapRequestById(
        this.studentSieId,
        this.tapRequestId
      );

      if (data?.id) {
        const {
          id,
          facilitatorDiscussionOccurred,
          facilitatorDiscussionDescription,
          facilitatorDiscussionFile,
          studentEducationalFunctioningDesc,
          recommendedPlacement,
          recommendedPlacementId,
          recommendedPlacementGradeId,
          recommendedPlacementJustification,
          recommendedPlacementFocusTypeId,
          recommendedPlacementDescription,
          isStudentPrescholar,
          questionnaireAnswers,
          arrangements,
          staffMembers,
          documents,
          facilitatorName,
          municipality,
          statusId,
          statusName,
          statusReasons,
          returnReason,
           requestType,
           determinationType,
           academicYear,
           servicesSummary,
           servicesSummaryPreviousYear,
          email,
          familyMemberName,
          phone,
          relativeId,
        } = data;
        this.setCurrentStatus({
          id: statusId,
          name: statusName,
          reason: returnReason,
          reasonTypes: [...statusReasons],
        });
        this.model.requestType = requestType;
        this.model.determinationType = determinationType;
        this.termsSelected =
          this.currentTabSectionsState[
            this.enums.sections['Terminos y Responsabilidades']
          ].readonly || this.readOnly;

        this.model.facilitatorName = facilitatorName;
        this.model.email = email;
        this.model.familyMemberName = familyMemberName;
        this.model.phone = phone;
        this.model.relativeId = relativeId;
        this.model.municipality = municipality;
        this.model.academicYear = academicYear;
        this.model.id = id;
        this.model.statusId = statusId;
        this.model.documents = documents;

        this.headerInformation = {
          studentInfo: data.studentInfo,
          schoolName: data.schoolName,
          status: data.statusName,
          impediment: data.impediment,
          requestNumber: data.businessId,
        };

        facilitatorDiscussionOccurred &&
          (this.model.facilitatorDiscussionOccurred = facilitatorDiscussionOccurred);
        facilitatorDiscussionDescription &&
          (this.model.facilitatorDiscussionDescription = facilitatorDiscussionDescription);
        facilitatorDiscussionFile &&
          (this.model.facilitatorDiscussionFile = facilitatorDiscussionFile);
        studentEducationalFunctioningDesc &&
          (this.model.studentEducationalFunctioningDesc = studentEducationalFunctioningDesc);
        this.model.alternativeUbication = {
          ageRange:
            recommendedPlacementGradeId == 1
              ? { id: 1, codeType: 'PeiAlternatePlacementPrescholar' }
              : { id: 2, codeType: 'PeiAlternatePlacement' },
          alternative: recommendedPlacementId
            ? { id: recommendedPlacementId, text: recommendedPlacement }
            : null,
          justification: recommendedPlacementJustification,
          description: recommendedPlacementDescription,
          focusType: {
            id: recommendedPlacementFocusTypeId,
          },
          gradeId: recommendedPlacementGradeId,
          grade: { id: recommendedPlacementGradeId },
        };
        questionnaireAnswers &&
          (this.model.sectionsQuestions = questionnaireAnswers);

        arrangements &&
          (this.model.arrangements = this.prepareAreaArrangements(
            arrangements
          ));
        staffMembers &&
          (this.model.requesters =
            staffMembers?.map(
              ({
                id,
                fullName,
                workPosition,
                workPositionId,
                telephoneNumber,
                email,
                signed,
                signDate,
                signedBy,
              }) => ({
                id,
                name: fullName,
                position: {
                  id: workPositionId || null,
                  name: workPosition || null,
                },
                phone: telephoneNumber,
                email,
                signed: signed || !!id,
                signDate,
                signedBy,
              })
            ) || []);
        questionnaireAnswers &&
          (this.model.purposes = this.model.purposes.map(
            ({ questionId, answerId, text }) => ({
              questionId,
              answerId,
              text,
              description:
                questionnaireAnswers.find((c) => c.questionId === questionId)
                  ?.otherAnswerText || null,
              selected:
                questionnaireAnswers?.some(
                  (c) => c.questionId === questionId
                ) || false,
            })
          ));

        servicesSummary &&
          (this.model.servicesSummary = servicesSummary.map(
            ({
              id,
              cost,
              frequency,
              service,
              subtotal,
              other,
              itinerantService,
              therapyFrequencyId,
              therapyServiceModalityId,
              therapyDurationId,
              peiValidationMessage,
            }) => ({
              id,
              cost,
              frequency,
              service,
              subtotal,
              other,
              itinerantService: this.availableCatalogOptions.itinerantServices.find(
                (x) => x.id == itinerantService
              ),
              therapyFrequency: this.availableCatalogOptions.frequencies.find(
                (x) => x.id == therapyFrequencyId
              ),
              therapyServiceModality: this.availableCatalogOptions.modalities.find(
                (x) => x.id == therapyServiceModalityId
              ),
              therapyDuration: this.availableCatalogOptions.durations.find(
                (x) => x.id == therapyDurationId
              ),
              peiValidationMessage,
            })
          ));

        this.fillDocuments();
        this.catalogs.servicesPreviousYear = servicesSummaryPreviousYear;
        this.componentKey++;
      } else {
        //This is for reset status when request is not exist.
        this.setCurrentStatus({
          id: 'NONE',
          name: '',
          reason: '',
          reasonTypes: [],
        });
      }
    },
    resetMsgErrorSection1() {
      this.showMsgErrorSection1 = false;
    },
    resetTypeValidation(value) {
      this.typeValidationError = value;
    },
    onExpanded(value) {
      this.isExpandedSection1 = value;
    },
    async onContinue() {
      if (!this.model.facilitatorDiscussionOccurred) {
        this.showMsgErrorSection1 = true;
        return;
      }
      const isValid = await this.$refs.observer.validate();
      if (
        !isValid ||
        (this.typeValidationError !== null && this.typeValidationError == true)
      ) {
        this.ShowToast(
          '',
          'Favor de completar los campos requeridos.',
          'error'
        );
        return;
      }

      const { data: exist } = await hasTapRequest(
        this.studentSieId,
        this.model.academicYear.id
      );

      if (exist) {
        this.ShowToast(
          'Atención',
          `El estudiante ya cuenta con una solicitud en proceso de asistencia técnica para ubicación del estudiante en el año ${this.model.academicYear.description}.`,
          'error'
        );
        return;
      }
      const payload = modelToContinuePayload(
        this.studentSieId,
        this.model.academicYear.id,
        this.model
      );

      const { data } = await this.$ApiPost(
        'api/taprequests',
        objectToFormData(payload)
      );

      if ((data && !data?.hasErrors) || false) {
        const { id, statusId, statusName, returnReason, statusReasons } = data;

        this.setCurrentStatus({
          id: statusId,
          name: statusName,
          reason: returnReason,
          reasonTypes: [...statusReasons],
        });

        this.model.id = id;
        this.tapRequestId = id;
        this.model.statusId = statusId;
        this.isExpandedSection1 = false;
      } else {
        this.ShowToast('Error', data.validations[0].name, 'error');
        return;
      }
    },
    async save() {
      this.model.IsUpdatingAcademicYear =
        this.isReadOnly && this.hasPermisionChangeAcademicYear;

      let payload = modelToPayload(
        this.studentSieId,
        this.model.academicYear.id,
        this.model
      );

      const data = objectToFormData(payload, { indices: true });

      let index = 0;
      let indexFile = 0;

      this.document.data.files.forEach((element) => {
        if (!element.id) {
          data.append(`documents[${index}].file`, element.file, element.name);
          data.append(
            `documents[${index}].documentTypeId`,
            element.documentTypeId
          );
          index++;
        }
        indexFile++;
      });

      try {
        const request = await this.$ApiPut(
          `api/taprequests/${this.model.id}`,
          data
        );

        if (this.model.facilitatorDiscussionOccurred) {
          this.ShowToast(
            'Confirmación',
            'La solicitud ha sido guardada exitosamente.',
            'success'
          );

          if (request.data) {
            const { documents, servicesSummary } = request.data;

            servicesSummary &&
              (this.model.servicesSummary = servicesSummary.map(
                ({
                  id,
                  cost,
                  frequency,
                  service,
                  subtotal,
                  other,
                  itinerantService,
                  therapyFrequencyId,
                  therapyServiceModalityId,
                  therapyDurationId,
                  peiValidationMessage,
                }) => ({
                  id,
                  cost,
                  frequency,
                  service,
                  subtotal,
                  other,
                  itinerantService: this.availableCatalogOptions.itinerantServices.find(
                    (x) => x.id == itinerantService
                  ),
                  therapyFrequency: this.availableCatalogOptions.frequencies.find(
                    (x) => x.id == therapyFrequencyId
                  ),
                  therapyServiceModality: this.availableCatalogOptions.modalities.find(
                    (x) => x.id == therapyServiceModalityId
                  ),
                  therapyDuration: this.availableCatalogOptions.durations.find(
                    (x) => x.id == therapyDurationId
                  ),
                  peiValidationMessage,
                })
              ));

            this.model.documents = documents;
            this.fillDocuments();
          }

          return true;
        } else {
          this.showMsgErrorSection1 = true;
          this.resetModel();
          this.document.data = {
            files: [],
            types: [],
          };
          this.model.requestType = null;
          await Promise.all([this.getPurposes(), this.getStudentTapRequest()]);
        }

        return false;
      } catch {
        return false;
      }
    },
    async submit() {
      const valid = await this.$refs['main-form'].validate();
      if (!valid) {
        this.ShowToast('', 'Información incompleta.', 'error');
        return;
      }

      const validDocuments = this.validateDocuments();
      if (!validDocuments) return;

      const saved = await this.save();
      if (!saved) {
        return;
      }

      await this.$ApiPost(`api/taprequests/${this.model.id}/submit`)
        .then(async (data) => {
          if (data.data.hasErrors === true) {
            data.data.validations
              .filter((v) => v.name != null)
              .forEach((validation) => {
                this.ShowToast('Error', validation.name, 'error');
              });

            return;
          } else {
            this.tapRequestId = this.model.id;
            await this.getStudentTapRequest();
            this.isSubmitted = true;
            this.ShowToast(
              'Confirmación',
              'La solicitud ha sido sometida exitosamente.',
              'success'
            );
          }
        })
        .catch(() => {
          this.ShowToast(
            'Error',
            'La solicitud no pudo ser sometida correctamente.',
            'error'
          );
        });
    },
    resetModel() {
      this.model = modelInitialState(this.studentSieId);
    },
    async getDocumentTypesByCode(code) {
      getDocumentTypesByCode(code).then((response) => {
        response.data.forEach((element) => {
          this.document.documentTypes.push({
            id: element.id,
            name: element.name,
          });
        });
      });
    },
    // Getting data from BackupDocument component.
    async gettingDocument(data) {
      this.document.data = data;
    },
    // Filling component documents.
    fillDocuments() {
      this.document.data = {
        files: [],
        types: [],
      };
      if (this.model.documents && this.model.documents.length > 0) {
        this.model.documents
          .filter((x) => x.document.documentTypeId != 175)
          .forEach((element) => {
            this.document.data.files.push({
              name: element.filename,
              documentType: element.document.documentTypeId,
              documentTypeName: element.document.documentTypeName,
              id: element?.documentId,
              readOnly: element.readOnly,
              inServer: true,
              createdDate: element.createdDate,
              userName: element.userName,
              userFullName: element.userFullName,
              isAmendmentDocument: element.isAmendmentDocument,
            });
            this.document.data.types.push(element.document.documentTypeId);
          });
      }
      this.documentLength++;
    },
    validateDocuments() {
      if (
        this.currentTabSectionsState[this.enums.sections['Documentos']].readonly
      ) {
        return true;
      }

      let tapRequestRenewalNotRequireSAEE08Document = (
        this.sysParameters.find(
          (x) => x.name === 'TapRequestRenewalNotRequireSAEE08Document'
        ) || {}
      ).staticValue;

      const hasDocuments =
        this.document.data != undefined && this.document.data.files.length > 0;
      if (!hasDocuments) {
        const noDocError = 'Favor anejar un documento.';
        this.$refs['main-form'].setErrors({ document: [noDocError] });
      }

      let hasSAEE08File = this.document.data.types.includes(177);

      if (
        this.model.requestType == UTA_MANAGEMENT_REQUEST_TYPE.RENOVACION &&
        new Date() >= new Date(tapRequestRenewalNotRequireSAEE08Document)
      ) {
        hasSAEE08File = true;
      }

      let errorMsg = '';
      if (!hasSAEE08File) {
        errorMsg =
          'Para someter la Solicitud, es requerido anejar el documento de SAEE-08 - Minuta de Reunión.';
        this.$refs['main-form'].setErrors({ document: [errorMsg] });
        this.ShowToast('', errorMsg, 'error');
      }

      const hasProposalServiceFile =
        this.model.requestType == UTA_MANAGEMENT_REQUEST_TYPE.QUERELLA ||
        this.model.requestType == UTA_MANAGEMENT_REQUEST_TYPE.RENOVACION
          ? this.document.data.types.includes(219)
          : true;

      if (!hasProposalServiceFile) {
        let hasProposalServiceErrorMsg =
          'Para someter la solicitud es requerido anejar el documento de la Propuesta de Servicios.';
        this.$refs['main-form'].setErrors({
          document: [errorMsg, hasProposalServiceErrorMsg],
        });
        this.ShowToast('', hasProposalServiceErrorMsg, 'error');
      }

      return hasDocuments && hasSAEE08File && hasProposalServiceFile;
    },
    async fillData() {
      await Promise.all([
        this.getDocumentTypesByCode('TapRequest'),
        this.getPositions(),
        this.getStudentTapRequest(),
        this.fetchServices(),
        this.fetchTherapyServicesFilters(),
      ]);
      if (this.tapRequestId) {
        this.fetchIsSchoolContractDirectPayment();
      }
    },
    async fetchServices() {
      const data = await getCentralLevelServices();

      this.catalogs.services = [...data];
    },
    async fetchTherapyServicesFilters() {
      const data = await getTherapyservicesfilters();

      this.catalogs.frequencies = data.frequencies;
      this.catalogs.modalities = data.modalities;
      this.catalogs.durations = data.durations;
    },
    async fetchIsSchoolContractDirectPayment() {
      try {
        const { data } = await _isSchoolContractDirectPayment(this.tapRequestId);
        this.isSchoolContractDirectPayment = data;
      } catch {
        this.isSchoolContractDirectPayment = false;
      }
    },
    addServiceToSummary(item) {
      this.model.servicesSummary.push(item);

      alert.methods.ShowToast(
        'Confirmación',
        'El servicio se ha añadido exitosamente.',
        'success'
      );
    },
    removeServiceFromSummary(serviceId) {
      const index = this.model.servicesSummary
        .map((c) => c.service.id)
        .indexOf(serviceId);

      this.model.servicesSummary.splice(index, 1);

      alert.methods.ShowToast(
        'Confirmación',
        'El servicio ha sido eliminado exitosamente.',
        'success'
      );
    },
  },
  beforeCreate() {
    registerStatusManagementStore();
  },
  async created() {
    if (this.$route.params.tapRequestId) {
      this.tapRequestId = this.$route.params.tapRequestId;
    }

    await Promise.all([
      await this.getPurposes(),
      await this.fillData(),
      await this.getMunicipalities(),
      await this.getCanSignPei(),
      await this.getAcademicYears(),
      await this.getCurrentAcademicYear(),
      await this.getSysParam(),
    ]);
  },
  destroyed() {
    unregisterStatusManagementStore();
  },
};
</script>

<style scoped>
.info-icon {
  position: absolute;
  left: -7px;
}

.disabled-page {
  pointer-events: none;
}

.tag-badge {
  display: inline-block;
  padding-right: 1em;
  height: 42px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  cursor: pointer;
  margin-bottom: 10px;
}

.dot {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: inline-block;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
}
.orange-icon {
  color: #ff7058;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 25px/30px Lato;
  letter-spacing: 0;
  color: #11291b;
  display: inline-block;
}
@media screen and (max-width: 765px) {
  .tag-badge-title {
    font-size: 18px;
  }
}
.border-box {
  border: 1px solid #e2e2e2;
  border-radius: 5px 5px 0px 0px;
  padding: 20px;
  width: 100%;
}
.border-box.signed,
.border-box.unsigned {
  border-radius: 0px 0px 5px 5px;
  border-top: none;
  padding: 0 !important;
  height: 65px;
}
.border-box.error {
  background: #ffebeb 0% 0% no-repeat padding-box;
  border: 1px solid #c9545e;
}

.signed {
  background-color: #2db782;
  color: white;
}
.unsigned {
  background-color: #f7f7f7;
  color: black;
}
.question {
  box-shadow: -3px 1px 3px #00000029;
  align-content: space-between;
}

.item-pane {
  justify-content: space-between;
  min-width: 50%;
  box-shadow: -3px 1px 3px #00000029;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.question-box {
  width: 65px;
  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box-number {
  font: Bold 32px/19px Lato;
}
.question-line.pl-55 {
  padding-left: 55px !important;
}
.question-line p {
  padding-bottom: 0px;
}

.question-line p >>> p {
  margin-bottom: 0px !important;
}

.header {
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
}

.row-checkbox {
  width: 20px;
  height: 20px;
  width: 10%;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  opacity: 1;
}

.row-text {
  width: 90%;
}

.row-odd {
  background-color: #fafbfa;
}

.row-even {
  background-color: #ffffff;
}

.text-fix {
  font-weight: 400;
}
.relative-top-10 {
  position: relative;
  top: 0.8em;
}
#ubicationWrapper >>> .tag-badge-title-info {
  font-size: 15px;
}
.blured-body {
  left: 119px;
  top: 100px;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 11;
}
.blured-body {
  backdrop-filter: blur(8px);
}
.custom-control-input:disabled ~ .custom-control-label,
.custom-control-input[disabled] ~ .custom-control-label {
  color: white !important;
}
</style>
